export default {
  title: 'Pedidos perdidos',
  card_title: 'Correos de pedidos perdidos',
  intro:
    'Si nadie acepta un pedido en {{minutes}} minutos, se rechaza automáticamente. Todos los de esta lista recibirán entonces un correo con el pedido para que alguien pueda hacer el seguimiento.',
  default: {
    owner: 'Propietario del restaurante',
    partner: 'Partner',
    owner_missing: 'El propietario del restaurante ({{email}}) no recibirá estos correos.',
    partner_missing: 'La dirección predeterminada del partner ({{email}}) no recibirá estos correos.',
  },
  empty: 'Nadie se enteraría de los pedidos perdidos. Añade al menos un correo para guardar.',
  save_error: 'No se han podido guardar los correos. Comprueba tu conexión e inténtalo de nuevo.',
  load_error: 'No se han podido cargar los correos. Comprueba tu conexión e inténtalo de nuevo.',
  unavailable: 'Los correos de pedidos perdidos no están disponibles para este restaurante.',
  buttons: {
    save: 'Guardar',
    retry: 'Reintentar',
  },
  toasts: {
    saved: 'Correos de pedidos perdidos guardados',
  },
};
